import React, {useEffect, useRef, useState} from "react";
import {Button, ButtonProps} from "reactstrap";

const LongClickButton: React.FC<ButtonProps> = (props) => {
    const timeout = useRef<ReturnType<typeof setTimeout>>();
    const [active, setActive] = useState(false);
    const {children, onClick} = props;

    const stopCount = () => {
        clearTimeout(timeout.current);
        timeout.current = undefined;
        setActive(false);
    };

    useEffect(() => () => clearTimeout(timeout.current), []);

    const startCount = (event: React.SyntheticEvent<HTMLButtonElement>) => {
        if (props.disabled || timeout.current !== undefined) return;
        setActive(true);
        timeout.current = setTimeout(() => {
            setActive(false);
            onClick?.(event as React.MouseEvent<HTMLButtonElement>);
        }, 2000);
    };

    return <Button
        {...props}
        className={`${props.className ?? ""} lcb lcb-${props.color} ${active ? "lcb-active" : ""}`}
        onPointerDown={(event) => { if (event.button <= 0) startCount(event); }}
        onPointerUp={stopCount}
        onPointerLeave={stopCount}
        onPointerCancel={stopCount}
        onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                if (!event.repeat) startCount(event);
            }
        }}
        onKeyUp={stopCount}
        onBlur={stopCount}
        onClick={(event) => event.preventDefault()}
    >
        {children}
    </Button>;
};

export default LongClickButton;
